module.exports = __webpack_public_path__ + "static/img/home_fn_content_03.dab8bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_03.png
// module id = OeZH
// module chunks = 34